enum OpenAIRole {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
  Tool = 'tool',
}

enum OpenAIModel {
  Gpt4_1 = 'gpt-4.1',
  Gpt4_1Mini = 'gpt-4.1-mini',
  Gpt5 = 'gpt-5',
  Gpt5Mini = 'gpt-5-mini',
  Gpt5_1 = 'gpt-5.1',
  Gpt5_2 = 'gpt-5.2',
}

enum OpenAIFinishReasonType {
  Stop = 'stop',
  Length = 'length',
  ToolCalls = 'tool_calls',
  FunctionCall = 'function_call',
  ContentFilter = 'content_filter',
}

export {OpenAIFinishReasonType, OpenAIModel, OpenAIRole};
